import { Box, Grid, Heading, ResponsiveContext, Text, Image, Stack, Anchor } from "grommet";
import * as React from "react";
import { useUser } from "../utils/AccountStore";
import DarkModeSwitch from "../components/DarkModeSwitch";
import { Link, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import LinkButton from "../components/LinkButton";
import MenuItem from "../components/MenuItem";
import { GetMetadata, Metadata } from "../utils/MetadataStore";
import { Scope, createScope, animate, createSpring, svg } from "animejs";

const Home = () => {
    const logoMaxSize = screen?.width > 600 ? "200px" : "75%";

    const size = React.useContext(ResponsiveContext);
    const location = useLocation();

    const [loading, setLoading] = React.useState(true);
    const [entityLoading, setEntityLoading] = React.useState(true);
    const { user } = useUser();

    const navigate = useNavigate();

    const [metadata, setMetadata] = React.useState({} as Metadata);

    React.useEffect(() => {
        GetMetadata().then((res) => {
            setMetadata(res);
        });
    }, [user]);

    const root = React.useRef(null);
    const scope = React.useRef<Scope | null>(null);

    // const [rotations, setRotations] = useState(0);

    // React.useEffect(() => {
    //     if (scope) {
    //         scope.current = createScope({ root }).add((self) => {
    //             // Every anime.js instances declared here are now scopped to <div ref={root}>

    //             let motionPath = svg.createMotionPath("ellipse");
    //             if (motionPath) {
    //                 animate(".logo", {
    //                     ease: "linear",
    //                     loop: true,
    //                     duration: 10000,
    //                     x: motionPath.translateX,
    //                     y: motionPath.translateY,
    //                 });
    //             }
    //         });
    //         // return () => scope?.current?.revert();
    //     }
    //     // Properly cleanup all anime.js instances declared inside the scope
    // }, [scope]);

    return (
        <Box ref={root}>
            {user && (
                <Box align="center" justify="between">
                    <Box pad={"large"} justify="center" background={"url(/images/background.png)"} height={{ min: "35vh" }}>
                        <Box gap={"medium"}>
                            <Text size="xlarge" color="white" textAlign="start" style={{ paddingLeft: "10px" }}>
                                Welcome!
                            </Text>
                            <Image className="logo" margin="small" fit="contain" src={metadata.eventLogo} width={logoMaxSize} />
                            {/* <LinkButton primary path={"/profile"} label={"Registration"} color="brand" style={{ marginLeft: "10px" }}></LinkButton> */}
                        </Box>
                    </Box>
                    <Box pad={"large"} justify="center" align="center">
                        <Grid columns={["150px", "150px"]} gap={"small"}>
                            <MenuItem label="Agenda" align="center" path="/schedule" icon="/images/calendar.png"></MenuItem>
                            <MenuItem label="Event Map" align="center" path="/floorPlans" icon="/images/calendar.png"></MenuItem>
                            {/* <MenuItem label="Zones" path="/exhibitors" icon="/images/zones.png"></MenuItem> */}
                            <MenuItem label="Exhibition Zone" path="/exhibitionZone" icon="/images/puzzle.png"></MenuItem>
                            <MenuItem label="QR Code Scanner" align="center" path="/scanner" icon="/images/scanner.png"></MenuItem>
                        </Grid>
                        <Anchor href="https://airtable.com/app6kg5Skiaxo2N7M/shr82uWo8EJyYDIU6" target="_blank">
                            <Box justify="center" align="center" pad={{ vertical: "large", horizontal: "medium" }} margin={{ top: "medium" }} background={"brand"} round="small" fill>
                                <Text size="medium" weight={"bold"} color="white">
                                    Learn about the DreamWorks partnership
                                </Text>
                            </Box>
                        </Anchor>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default Home;
